import { SET_SHARE_WECHAT } from '../../store/mutationTypes';
export default {
  props: {},
  data: function data() {
    return {
      visible: false
    };
  },
  computed: {
    shareWechat: function shareWechat() {
      return this.$store.state.shareWechat;
    }
  },
  methods: {
    handlerClose: function handlerClose() {
      this.$store.commit(SET_SHARE_WECHAT, false);
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};